import { LogoIconNombreSVG } from "@/Components/Index";
import { Link } from "react-router-dom";

type Props = {
  titles?: string;
  toLink?: string;
  classNamesIcon?: string;
  onClickDelete?: () => void; //Eliminamos la orden de compra
  iconsView?: boolean;
  viewSearHome?: boolean;
};

export const HeaderPlpWeb = ({
  titles,
  toLink = "/Electrónica",
  classNamesIcon,
  onClickDelete,
  iconsView = true,
  viewSearHome = false,
}: Props): JSX.Element => {
  return (
    <div className="ps_container_developArg d-flex">
      <div className="d-full p-1">
        <div className="d-flex justify-content-between justify-content-center align-items-center mx-auto my-auto">
          <div className="p-0 mr-5">
            <Link className="header__back" to={toLink} onClick={onClickDelete}>
              <i
                className={!iconsView ? "" : "icon-chevron-left text-white"}
                style={{ fontSize: 30 }}></i>
            </Link>
          </div>
          <div className="p-0 ml-5">
            <Link className="ps-logo" to={"/"} onClick={onClickDelete}>
              <LogoIconNombreSVG />
            </Link>
          </div>
        </div>
      </div>
      {viewSearHome ? (
        <div className="p-1 flex-fill">
          <div className="d-flex justify-content-center align-items-center">
            <label className="input-with-icon">
              <i className="icon-magnifier" aria-hidden="true" />
              <input
                type="text"
                className="form-control text-center"
                placeholder="¿Qué estas buscando hoy ?"
                //onChange={onChange}
                aria-label="search"
              />
            </label>
          </div>
        </div>
      ) : (
        <>
          <div className="header__center d-flex justify-content-center mx-auto my-auto align-items-center">
            <h4 className="text-white mt-3">{titles}</h4>
          </div>
          <div className="header__rights">
            <div className="d-flex justify-content-end align-items-center mx-auto">
              <Link className="header__back mt-2" to={"/"}>
                <i className={classNamesIcon} style={{ fontSize: 30 }}></i>
              </Link>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
